module.exports = __webpack_public_path__ + "img/pocket-14_jp.e061949.jpg";